import React from "react";
import Download from "../../components/lamppost/download";

const DownloadPage = () => <Download lang="sc" path="download" />;

export default DownloadPage;
